module.exports = __webpack_public_path__ + "img/204.ca021dc3.png";